<template>
  <multiselect
    :value="selectedOption"
    :options="effectiveOptions"
    :label="textField"
    :track-by="valueField"
    :placeholder="placeholder"
    :searchable="searchable"
    :allow-empty="allowEmpty"
    :show-labels="false"
    :loading="loading"
    :disabled="disabled"
    select-label=""
    selected-label=""
    deselect-label=""
    @input="onInput"
  >
    <template slot="noResult">Nenhum resultado encontrado.</template>
    <template slot="noOptions">Lista vazia.</template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'material-combo',
  components: { Multiselect },
  props: {
    value: { type: [String, Number, null], default: '' },
    options: { type: Array, default: () => [] },
    // Aceita um kendo.data.DataSource diretamente — o wrapper sincroniza
    // os dados via bind('change'), evitando refactor no controller.
    dataSource: { type: Object, default: null },
    textField: { type: String, required: true },
    valueField: { type: String, default: 'id' },
    placeholder: { type: String, default: 'Selecione' },
    searchable: { type: Boolean, default: true },
    allowEmpty: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      dsOptions: []
    }
  },
  computed: {
    effectiveOptions() {
      if (this.dataSource && typeof this.dataSource.data === 'function') {
        return this.dsOptions
      }
      return this.options
    },
    selectedOption() {
      const v = this.value
      if (v === '' || v === null || v === undefined) return null
      return this.effectiveOptions.find(
        o => String(o[this.valueField]) === String(v)
      ) || null
    }
  },
  methods: {
    onInput(opt) {
      const newVal = opt ? opt[this.valueField] : ''
      this.$emit('input', newVal != null ? String(newVal) : '')
      this.$emit('change', opt || null)
    },
    syncFromDataSource() {
      if (this.dataSource && typeof this.dataSource.data === 'function') {
        this.dsOptions = this.dataSource.data().toJSON
          ? this.dataSource.data().toJSON()
          : [...this.dataSource.data()]
      }
    }
  },
  mounted() {
    if (this.dataSource && typeof this.dataSource.bind === 'function') {
      this.syncFromDataSource()
      this._dsChangeHandler = () => this.syncFromDataSource()
      this.dataSource.bind('change', this._dsChangeHandler)
    }
  },
  beforeDestroy() {
    if (this.dataSource && this._dsChangeHandler && typeof this.dataSource.unbind === 'function') {
      this.dataSource.unbind('change', this._dsChangeHandler)
    }
  }
}
</script>

<style>
/* Tema material leve para combinar com o restante do app (Materialize). */
.multiselect {
  min-height: 36px;
  font-family: inherit;
  font-size: 14px;
}
.multiselect__tags {
  min-height: 36px;
  padding: 6px 40px 0 8px;
  border: 0;
  border-bottom: 1px solid #9e9e9e;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}
.multiselect--active .multiselect__tags {
  border-bottom-color: #26a69a;
}
.multiselect__single,
.multiselect__input {
  background: transparent;
  font-size: 14px;
  padding: 4px 0 0 0;
  margin-bottom: 6px;
  line-height: 20px;
}
.multiselect__placeholder {
  color: #9e9e9e;
  padding-top: 4px;
  margin-bottom: 6px;
}
.multiselect__select {
  height: 36px;
}
.multiselect__select::before {
  border-color: #9e9e9e transparent transparent;
}
.multiselect__content-wrapper {
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}
.multiselect__option--highlight,
.multiselect__option--highlight:after {
  background: #26a69a;
}
.multiselect__option--selected.multiselect__option--highlight,
.multiselect__option--selected.multiselect__option--highlight:after {
  background: #ef6c00;
}
</style>



// WEBPACK FOOTER //
// src/components/Shared/Material/MaterialCombo.vue